import {
    ADMIN_LOGIN_ROUTE,
    ADMIN_PROFILE_ROUTE,
    CART_ROUTE,
    CHECKOUT_ROUTE,
    CONTACT_ROUTE,
    CUSTOMER_PROFILE_ROUTE,
    MAIN_ROUTE,
    TERMS_ROUTE,
    NOUVEAUTES_ROUTE,
    ARRIVES_ROUTE
} from "@/utils/constants.js";

const CUSTOMER_PROFILE_FAB_SECTIONS = new Set(["purchases", "favorites"]);

/**
 * Routes where the mobile/tablet cart FAB may appear (guests and customers; not admin).
 * @param {string} pathname
 * @param {string} [search] location.search including leading "?" or raw query
 */
export function isMobileCartFabRoute(pathname, search = "") {
    if (!pathname) {
        return false;
    }
    if (
        pathname === CART_ROUTE
        || pathname === CHECKOUT_ROUTE
        || pathname === TERMS_ROUTE
        || pathname === ADMIN_LOGIN_ROUTE
        || pathname === ADMIN_PROFILE_ROUTE
        || pathname.startsWith(`${ADMIN_PROFILE_ROUTE}/`)
    ) {
        return false;
    }
    if (pathname === MAIN_ROUTE || pathname === CONTACT_ROUTE
        || pathname === NOUVEAUTES_ROUTE || pathname === ARRIVES_ROUTE) {
        return true;
    }
    if (pathname.startsWith("/product/")) {
        return true;
    }
    if (pathname.startsWith("/orders/")) {
        return true;
    }
    if (pathname === CUSTOMER_PROFILE_ROUTE || pathname.startsWith(`${CUSTOMER_PROFILE_ROUTE}/`)) {
        const query = search.startsWith("?") ? search.slice(1) : search;
        const section = new URLSearchParams(query).get("section");
        if (!section) {
            return true;
        }
        return CUSTOMER_PROFILE_FAB_SECTIONS.has(section);
    }
    return false;
}
